import { Helmet } from "react-helmet";
import { Typography } from "@mui/material";
import { useIntl } from "react-intl";
import common from "@/i18n/definitions/common";
import homepage from "@/i18n/definitions/homepage";
import TilastotCard from "@/scenes/TilastotCard";
import { addIndex, map, values } from "ramda";
import Koulutusmuotokortti from "@/components/03-templates/Koulutusmuotokortti";
import { getKoulutusmuodot } from "@/utils/common";
import { ReactElement } from "react";
import JarjestajatCard from "@/scenes/KaikkiJarjestajat/JarjestajatCard.tsx";

const Home = (): ReactElement => {
  const intl = useIntl();
  const { formatMessage, locale } = intl;

  const koulutusmuodot = getKoulutusmuodot(intl);

  return (
    <article className="px-8 py-16 md:px-12 lg:px-32 xxl:px-0 xxl:max-w-8xl mx-auto">
      <Helmet htmlAttributes={{ lang: locale }}>
        <title>Oiva - {formatMessage(common.frontpage)}</title>
      </Helmet>
      <Typography component="h1" variant="h1" className="py-4">
        {formatMessage(homepage.header)}
      </Typography>
      <Typography sx={{
        marginBottom: "16px"
      }}>
        {formatMessage(homepage.infotext)}
      </Typography>
      <section>
        <Typography component="h2" variant="h2" className="py-4">
          {formatMessage(common.jarjestamisJaYllapitamisluvatOtsikko)}
        </Typography>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 justify-items-auto">
          {addIndex(map)(
            (koulutusmuoto, index) => (
              <Koulutusmuotokortti
                key={`koulutusmuotokortti-${index}`}
                koulutusmuoto={koulutusmuoto}
              />
            ),
            values(koulutusmuodot)
          )}
          <JarjestajatCard></JarjestajatCard>
        </div>
      </section>
      <section className="pt-12">
        <Typography component="h2" variant="h2" className="py-4">
          {formatMessage(common.statistics)}
        </Typography>
        <TilastotCard></TilastotCard>
      </section>
    </article>
  );
};

export default Home;
